import { ROOM_FACILITIES_TYPE } from 'constants/index';

// The room-facility catalogue lives in the backend (settings payload `facilities`, 8 groups since
// the 2026-09-28 rename). These helpers turn it into the form state the page and RadioConvenience
// already expect, and back into the PUT body: every group, every child, in the backend's order.

export const toFacilityGroups = (catalogue = []) => catalogue.map((group) => ({
  group: group.name,
  vi: group.vi,
  en: group.en,
  children: (group.children || []).map((child) => ({
    facility: child.name,
    vi: child.vi,
    en: child.en,
    // The backend flags the featured children; RadioConvenience shows the "Nổi bật" pill on it.
    isFeatured: !!child.isFeatured,
    applyFor: ROOM_FACILITIES_TYPE.NO_ROOM,
    rooms: [],
  })),
}));

// Stored rows come from GET /places/:id/rooms/facilities, keyed by group and facility name. A place
// saved before the rename keeps the old groups, so every lookup falls back to the default.
export const mergeStoredFacilities = (groups, storedGroups = [], roomIds = []) => groups
  .map((group) => {
    const stored = storedGroups.find((item) => item.group === group.group);

    return {
      ...group,
      children: group.children.map((child) => {
        const match = (stored?.children ?? []).find((item) => item.facility === child.facility);

        if (!match) return child;

        return {
          ...child,
          applyFor: match.applyFor ?? child.applyFor,
          rooms: match.applyFor === ROOM_FACILITIES_TYPE.ALL_ROOMS
            ? roomIds
            : (match.rooms ?? []),
        };
      }),
    };
  });

export const toFacilitiesPayload = (groups) => groups.map((group) => ({
  group: group.group,
  children: group.children.map((child) => ({
    applyFor: child.applyFor,
    name: child.facility,
    rooms: child.rooms || [],
  })),
}));
